import React, { useState, useContext, useEffect } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { mapData } from '@/product/common/components'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import AppsheetContext from '@/product/context/thirdParty/appsheet/appsheetContext'
import AlertContext from '@/product/context/alert/alertContext'

const SyncInventory = () => {
    const [isLoading, setIsLoading] = useState(false)
    const appsheetContext = useContext(AppsheetContext)
    const alertContext = useContext(AlertContext)
    const { syncAppSheetData, responseStatus, clearResponse } = appsheetContext
    const { setAlert } = alertContext

    const validationArray = Yup.object({
        row_id: Yup.string().required('Row ID is required'),
    })

    const formik = useFormik({
        initialValues: {
            row_id: '',
            field: '_RowNumber',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            console.log(`SyncInventory values `, values)
            syncAppSheetData(values)
        },
    })

    useEffect(() => {
        if (responseStatus?.status) {
            setAlert(responseStatus?.message, responseStatus.status)
            formik.resetForm()
            setIsLoading(false)
            clearResponse()
        }
    }, [responseStatus])

    const searchInfo = [
        {
            label: 'Row ID',
            placeholder: 'Enter Row ID',
            class: `col-sm-6 col-md-4`,
            type: 'text',
            name: 'row_id',
            formik: formik,
        },
        {
            label: 'Active Agency',
            type: 'select',
            class: `col-sm-4 col-md-3`,
            isNoDefaultOptionValue: true,
            placeholder: 'Select Field',
            size: 'small',
            name: 'field',
            options: [
                { value: '_RowNumber', show: 'Row Number' },
                { value: 'Row ID', show: 'Row ID' },
                { value: 'barcode', show: 'Barcode' },
            ],
        },
    ]

    return (
        <>
            <Layout>
                <div className="dashboard commentManagement">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row d-flex justify-content-start">
                            {Object.values(mapData(searchInfo))}
                            <div className="mt-2 col-sm-6 col-md-4 text-left">
                                <PrimaryButton
                                    id="sync_inventory"
                                    label={
                                        isLoading ? `Loading` : `Sync Inventory`
                                    }
                                    type="submit"
                                    btnSize="medium"
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </Layout>
        </>
    )
}

export default SyncInventory
